import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../LanguageSwitcher';
import { getApiUrl } from '../../config';
import config from '../../config';
import './ActivationPage.css';

const ActivationPage = () => {
  const { hash } = useParams();
  const history = useHistory();
  const { t } = useTranslation();
  
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [isValidating, setIsValidating] = useState(true);
  const [isValid, setIsValid] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const validateHash = async () => {
      try {
        const response = await fetch(
          getApiUrl(config.api.endpoints.auth.validateHash(hash))
        );
        const data = await response.json();
        
        if (data.isValid) {
          setIsValid(true);
        } else {
          setError(t('activation.errors.invalidLink'));
        }
      } catch (error) {
        console.error('Ошибка при проверке хеша:', error);
        setError(t('activation.errors.validationError'));
      } finally {
        setIsValidating(false);
      }
    };

    if (hash) {
      validateHash();
    } else {
      setError(t('activation.errors.hashNotFound'));
      setIsValidating(false);
    }
  }, [hash, t]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password.length < 6) {
      setError(t('activation.errors.passwordMinLength'));
      return;
    }

    if (!/(?=.*[A-Za-z])(?=.*\d)/.test(password)) {
      setError(t('activation.errors.passwordRequirements'));
      return;
    }

    if (password !== passwordConfirm) {
      setError(t('activation.errors.passwordsNotMatch'));
      return;
    }

    setIsSubmitting(true);

          try {
            const response = await fetch(
              getApiUrl(config.api.endpoints.auth.setPassword),
              {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  hash: hash,
                  password: password,
                  passwordConfirm: passwordConfirm,
                }),
              }
            );

      if (!response.ok) {
        const errorData = await response.json();
        setError(errorData.message || t('activation.errors.setPasswordError'));
        setIsSubmitting(false);
        return;
      }

      const data = await response.json();
      setSuccess(true);
      setTimeout(() => {
        history.push('/cabinet');
      }, 2000);
    } catch (error) {
      console.error('Ошибка при установке пароля:', error);
      setError(t('activation.errors.serverError'));
      setIsSubmitting(false);
    }
  };

  if (isValidating) {
    return (
      <div className="activation-page">
        <LanguageSwitcher />
        <div className="activation-container">
          <div className="activation-loading">
            <div className="loading-spinner"></div>
            <p>{t('activation.loading')}</p>
          </div>
        </div>
      </div>
    );
  }

  if (!isValid) {
    return (
      <div className="activation-page">
        <LanguageSwitcher />
        <div className="activation-container">
          <div className="activation-error">
            <div className="error-icon">❌</div>
            <h2>{t('activation.errorTitle')}</h2>
            <p>{error}</p>
            <button onClick={() => history.push('/')} className="back-button">
              {t('common.backToHome')}
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (success) {
    return (
      <div className="activation-page">
        <LanguageSwitcher />
        <div className="activation-container">
          <div className="activation-success">
            <div className="success-icon">✅</div>
            <h2>{t('activation.successTitle')}</h2>
            <p>{t('activation.redirecting')}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="activation-page">
      <LanguageSwitcher />
      <div className="activation-container">
        <div className="activation-form-wrapper">
          <div className="activation-header">
            <h1>{t('activation.title')}</h1>
            <p>{t('activation.subtitle')}</p>
          </div>

          <form onSubmit={handleSubmit} className="activation-form">
            {error && (
              <div className="activation-error-message">
                {error}
              </div>
            )}

            <div className="activation-input-group">
              <label htmlFor="password">{t('activation.passwordLabel')}</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder={t('activation.passwordPlaceholder')}
                required
                disabled={isSubmitting}
                className="activation-input"
              />
            </div>

            <div className="activation-input-group">
              <label htmlFor="passwordConfirm">{t('activation.passwordConfirmLabel')}</label>
              <input
                type="password"
                id="passwordConfirm"
                value={passwordConfirm}
                onChange={(e) => setPasswordConfirm(e.target.value)}
                placeholder={t('activation.passwordConfirmPlaceholder')}
                required
                disabled={isSubmitting}
                className="activation-input"
              />
            </div>

            <button
              type="submit"
              disabled={isSubmitting || !password || !passwordConfirm}
              className="activation-submit-btn"
            >
              {isSubmitting ? t('activation.submitting') : t('activation.submitButton')}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ActivationPage;

